import { render } from "./EditQcm.vue?vue&type=template&id=63a0c73a"
import script from "./EditQcm.vue?vue&type=script&lang=js"
export * from "./EditQcm.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__